import { createSelector } from 'reselect'
import { get } from 'lodash'
import { participants as participantsLayout } from 'constants/layout'
import { PARTICIPANTS_BULK, PERSON_STATES, PROGRESS_STATES } from 'constants/enums'

const getParticipantsGrid = state => get(state,
  'api.participants.grid.list',
  [])


const getBulkType = state => get(state,
  `form.${participantsLayout.bulkForm}.values.bulkType`,
  '')

export function mapForBulk(participantsGrid, bulkType) {

  switch (bulkType) {
    case PARTICIPANTS_BULK.inactive.id:
      return participantsGrid.filter(p =>
        get(p, 'person.state.type', '') === PERSON_STATES.active.id)
        .map(p => p.id)

    case PARTICIPANTS_BULK.resendParentalConsent.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.resendParentalConsent'))
        .map(p => p.id)

    case PARTICIPANTS_BULK.toCeremony.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.changeAwardToCeremony'))
        .map(p => p.id)

    case PARTICIPANTS_BULK.offlineToComplete.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.changeOfflineAwardToComplete'))
        .map(p => p.id)

    case PARTICIPANTS_BULK.nextLevelInvitation.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.invitationToNextLevel'))
        .map(p => p.id)

    case PARTICIPANTS_BULK.collectEmails.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.sendMessage.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.assignLabels.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.unassignLabels.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.assignAwardLabels.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.unassignAwardLabels.id:
      return participantsGrid.map(p => p.id)

    case PARTICIPANTS_BULK.transferParticipants.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.transferParticipant'))
        .map(p => p.id)

    case PARTICIPANTS_BULK.resendConfirmationEmail.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.resendConfirmationEmail'))
          .map(p => p.id)

    case PARTICIPANTS_BULK.changeParentalConsent.id:
      return participantsGrid.filter(p =>
        get(p, 'bulkOptions.changeParentalConsent'))
          .map(p => p.id)

    default:
      return []
  }
}

export default createSelector([getParticipantsGrid, getBulkType],
  mapForBulk)
